<template>
  <v-container fill-height fluid grid-list-xl>
    <v-row justify="center">
      <v-col cols="12">
        <material-card color="green" flat full-width title="Категории каталога">
          <v-spacer />
          <v-dialog v-model="dialog">
            <template #activator="{ on, attrs }">
              <v-btn color="blue" dark class="mb-2" v-bind="attrs" v-on="on">
                Новая запись
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span
                  v-if="newItem"
                  class="headline"
                >Добавление Категории в {{ editedItem.parent_id }}</span>
                <span
                  v-if="!newItem"
                  class="headline"
                >Редактирование Категории</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-text-field
                    v-model="editedItem.name"
                    label="Название"
                    @change="trans"
                  />
                  <v-text-field v-model="editedItem.slug" label="Slug" />
                  <select-c
                    :open-dialog="dialog"
                    :default="editedItem.params"
                    @selected="UpdateParams"
                  />
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn color="blue darken-1" text @click="close">
                  Cancel
                </v-btn>
                <v-btn color="blue darken-1" text @click="save">
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-treeview
            ref="tree"
            :items="category"
            rounded
            hoverable
            activatable
            :active.sync="active"
          >
            <template #append="{ item }">
              <v-icon @click="editCategory(item)">
                mdi-pencil
              </v-icon>
              <v-icon @click="deleteCategory(item)">
                mdi-delete-outline
              </v-icon>
            </template>
            <template #label="{ item }">
              <v-card mr="5" :class="[{'teal': item.status === 'active'},{'red': item.status !== 'active'}, {'lighten-5': true}]">
                {{ item.name }}
                <span ml="5">{{ item.type }}</span>
              </v-card>
            </template>
          </v-treeview>
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  Categores,
  CreateOfferCategory,
  deleteOfferCategory
} from '@/graphql/category'
import { slugify } from 'transliteration'
import { ListToTree } from '@/mixins/tree'
import SelectC from '@/components/category/select'
export default {
    components: {
      SelectC
    },
    layout: 'dashboard',
    apollo: {
        Category: {
            query: Categores,
            result ({ data, loading }) {
                this.$set(this, 'category', ListToTree(data.categores))
            },
            update: data => data.categores
        }
    },
    data () {
        return {
            category: [],
            newItem: true,
            editedItem: {
                parent_id: 0,
                extras: [{}]
            },
            dialog: false,
            active: [],
            paramsList: []
        }
    },
    watch: {
        dialog (val) {
            if (val && this.newItem) {
            this.editedItem = Object.assign({
                    parent_id: 0,
                    extras: [{}]
                    })
            }
            if (this.active.length > 0) {
                this.editedItem.parent_id = this.active[0]
            }
        }
    },
    methods: {
      UpdateParams (val) {
          this.editedItem.params = val
      },
        editCategory (item) {
          this.newItem = false
          this.editedItem = Object.assign({}, item)
          this.dialog = true
        },
        deleteCategory (item) {
            if (confirm('Уверены что хотите удалить категорию ' + item.name)) {
             this.$apollo
                 .mutate({
                   mutation: deleteOfferCategory,
                   variables: {
                     id: item.id
                   }
                 })
                 .then((data) => {
                   this.$apollo.queries.Category.refetch()
                })
                 .catch((error) => {
                   console.error(error)
                })
            }
        },
        trans () {
            if (this.editedItem.slug === undefined || this.editedItem.slug.length < 1) {
                this.editedItem.slug = slugify(this.editedItem.name).replaceAll('-', '_')
            }
        },
         close () {
          this.dialog = false
        },
        save () {
           this.$apollo
               .mutate({
                 mutation: CreateOfferCategory,
                 variables: { input: this.editedItem }
               })
               .then((data) => {
                 this.$apollo.queries.Category.refetch()
               })
               .catch((error) => {
                 console.error(error)
               })

      this.close()
    }
  }
}
</script>
